import TextInput from '../../lib/TextField';
import en from '../../lang/en-us';
import { Button, Dialog } from '@material-ui/core';
import { connect } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { AuthState } from '../../redux-store/types/login';
import { SubmitButton, SubmitButtonWithLoader } from '../../lib/Button';
import { onLogout, updateFirstTimeSettings } from '../../redux-store/actions/login';
import { useState, useEffect } from 'react';
import { registerDevice } from '../../redux-store/actions/mobile';
import { RegisterDeviceReqBody } from '../../redux-store/types/mobile';
import { EncodeBase64 } from '../../utils/utilityFunctions';
import { isFingerPrintAvailable } from '../../lib/Authentication';
import SecureInput from '../../lib/TextField/SecureInput';

const { loginAuth } = en;

interface PinSetProps extends AuthState {
    updateFirstTimeSettings: (body: Partial<AuthState>) => void;
    registerDevice: (body: RegisterDeviceReqBody) => Promise<any>;
    onLogout: (body: any, ignore?: boolean) => Promise<any>;
    history: any;
}

const initState: { remove: boolean; message: string } = { remove: false, message: '' };

function LoginSetPin(props: PinSetProps) {
    const [pin, setPin] = useState<{ value: string; message: string }>({ value: '', message: '' });
    const [confirmPin, setConfirmPin] = useState<{ value: string; message: string }>({
        value: '',
        message: '',
    });

    const [deviceAuth, setDeviceAuth] = useState<boolean>(false);
    const [reset, setReset] = useState<{ remove: boolean; message: string }>(initState);
    const [loading, setLoading] = useState<boolean>(false);
    const [deviceLimitUsers, setDeviceLimitUser] =
        useState<{ remove: boolean; message: string }>(initState);

    const onSetPin = async () => {
        if (pin.value !== confirmPin.value) {
            alert('Not Match');
            return; // Need to handle error show
        }
        let payload: Partial<AuthState> = {
            enabledPin: true,
            isAutheticatedByDeviceOrPin: true,
        };
        const _window: any = window;
        const { platform, version, uuid, model } = _window?.device || {};
        try {
            setLoading(true);
            let res = await props.registerDevice({
                email: props.email,
                mobile: props.mobile,
                metaData: {
                    appType: 'MOBILE',
                    OSVersion: version,
                    deviceName: model,
                    deviceOS: platform,
                },
                deviceId: EncodeBase64(uuid),
                pin: EncodeBase64(pin.value),
                userId: props.pan,
                pan: props.pan,
                pekrn: props.pekrn,
            });

            if (res.status === 200) {
                props.updateFirstTimeSettings({
                    ...payload,
                    ...(!deviceAuth ? { skipDeviceAuth: true, initialSettingsAsked: true } : {}),
                });
            }
        } catch (err: any) {
            // type coercian
            if (err.name == 1001) {
                setReset((_prev) => ({ ..._prev, remove: true, message: err.message }));
                return;
            }
            if (err.name == 1002) {
                setDeviceLimitUser((_prev) => ({ ..._prev, remove: true, message: err.message }));
                return;
            }
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };

    const enableDeviceAuthentication = () => {
        props.updateFirstTimeSettings({
            enableTwoFactorAuth: true,
            initialSettingsAsked: true,
        });
    };
    const skipDeviceAuth = () => {
        props.updateFirstTimeSettings({
            skipDeviceAuth: true,
            initialSettingsAsked: true,
        });
    };

    useEffect(() => {
        const isDeviceAuthenticationAvailable = () => {
            isFingerPrintAvailable(
                () => setDeviceAuth(true),
                () => {
                    setDeviceAuth(false);
                },
            );
        };
        isDeviceAuthenticationAvailable();
    }, []);

    const onLimitReached = async () => {
        setLoading(true);
        const payload = {
            pan: props.pan,
            pekrn: props.pekrn,
            mobile: props.mobile,
        };
        try {
            await props.onLogout(payload);
        } catch (err: any) {
            alert(err.message);
        }
    };

    return (
        <div className="mobile_mode login-auth set-pin" aria-hidden="true">
            <div className="logo">
                {/* <a>
                    <img src="/images/left-arrow-white.svg" alt="back icon" />
                </a> */}
            </div>
            <div className="login-auth-content">
                <img src="/images/set-pin-icon.png" alt="" />
                <h3>{loginAuth.setPin}</h3>
                <SecureInput
                    onChange={({ target: { value } }) =>
                        setPin((prev) => ({
                            ...prev,
                            value: value.length > 4 ? prev.value : value,
                        }))
                    }
                    label={loginAuth.enterPin}
                    error={!!pin.message}
                    helperText={pin.message}
                    value={pin.value}
                    inputProps={{ inputMode: 'numeric' }}
                    type={'password'}
                    showSecure={false}
                />
                <TextInput
                    onChange={({ target: { value } }) =>
                        setConfirmPin((prev) => ({
                            ...prev,
                            value: value.length > 4 ? prev.value : value,
                        }))
                    }
                    label={loginAuth.confirmPin}
                    error={!!confirmPin.message}
                    helperText={confirmPin.message}
                    value={confirmPin.value}
                    inputProps={{ inputMode: 'numeric' }}
                />
                <SubmitButtonWithLoader
                    disabled={
                        !pin.value ||
                        pin.value !== confirmPin.value ||
                        pin.value.length < 4 ||
                        confirmPin.value.length < 4
                    }
                    onClick={onSetPin}
                    label="SET PIN"
                    loading={loading}
                    labelWhileLoading={'Sending'}
                    fullWidth
                />
            </div>
            <Dialog
                maxWidth={'sm'}
                open={!!props.enabledPin && !props.enableTwoFactorAuth && deviceAuth}
                aria-labelledby="enable-fingerprint-modal"
            >
                <div className="enable-fingerprint-modal">
                    <img src="/images/fingerprint-black.png" alt="" />
                    <h3>{loginAuth.enableFingerPrint}</h3>
                    <p>{loginAuth.enableFingerPrintInfo}</p>
                    <Button onClick={enableDeviceAuthentication} className="customBtn">
                        {loginAuth.enableTxt}
                    </Button>
                    <div onClick={skipDeviceAuth}>
                        <a>{loginAuth.skipNow}</a>
                    </div>
                </div>
            </Dialog>
            <Dialog maxWidth={'sm'} open={reset.remove} aria-labelledby="update-app-modal">
                <div className="update-app-modal">
                    <p>{reset.message}</p>
                    <div className="btns">
                        <SubmitButton
                            onClick={() => props.history.push('/stack/reset-devices')}
                            type="submit"
                            label="Remove Devices"
                        />
                        <Button onClick={() => setReset(initState)} className="customBtn cancelBtn">
                            Cancel
                        </Button>
                    </div>
                </div>
            </Dialog>
            <Dialog
                maxWidth={'sm'}
                open={deviceLimitUsers.remove}
                aria-labelledby="update-app-modal"
            >
                <div className="update-app-modal">
                    <p>{deviceLimitUsers.message}</p>
                    <div className="btns">
                        <SubmitButtonWithLoader
                            fullWidth
                            loading={loading}
                            labelWhileLoading={'Please wait'}
                            onClick={onLimitReached}
                            type="submit"
                            label="Okay"
                        />
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    updateFirstTimeSettings,
    registerDevice,
    onLogout,
})(LoginSetPin);
